import React, { useEffect, useState, Fragment } from 'react'
import { useParams } from 'react-router-dom'
import { getAllOrderDetails } from '../../api/orderDetailsApi'
import { FaMinus } from 'react-icons/fa6'
import Button from '../../components/Button'
import { Dialog, Transition } from '@headlessui/react'
import { getRollByUpc } from '../../api/rollApi'
import { toast } from 'react-toastify'
import Input from '../../components/Input'
import { addCut, deleteCut, getAllCuts, updateCut } from '../../api/cutApi'
import ProductLabel from '../../components/product/ProductLabel'
import { formatDate, formatNumber } from '../../utils/functions'
import { getOrderById } from '../../api/orderApi'
import OrderDetailPicker from '../../components/order/OrderDetailPicker'
import { AiFillEdit } from 'react-icons/ai'

const OrderShipmentPage = ({ title }) => {

    useEffect(() => {
        document.title = "İmperteks / " + title; // Sayfa başlığını güncelle
    }, [title]);

    const { orderId } = useParams()
    const [orderDetails, setOrderDetails] = useState([])
    const [cuts, setCuts] = useState([])
    const [isOpenCutModal, setIsOpenCutModal] = useState(false)
    const [isOpenCutUpdateModal, setIsOpenCutUpdateModal] = useState(false)
    const [upc, setUpc] = useState(100000009474)
    const [roll, setRoll] = useState()
    const [quantity, setQuantity] = useState("")
    const [order, setOrder] = useState({})
    const [selectedOrderDetail, setSelectedOrderDetail] = useState(null)
    const [selectedCutId, setSelectedCutId] = useState()

    useEffect(() => {
        getOrderById(orderId)
            .then(res => {
                setOrder(res.data)
            })
        getAllOrderDetails({ orderId })
            .then(res => {
                setOrderDetails(res.data)
            })
        getAllCuts({ orderId })
            .then(res => {
                setCuts(res.data)
            })
    }, [orderId])

    const onClickGetRoll = () => {
        getRollByUpc(upc)
            .then(res => {
                setRoll(res.data)
            }).catch(err => {
                toast.error('Ürün bulunamadı')
            })
    }

    const onClickAddCut = () => {
        const body = {
            rollId: roll?.id,
            quantity,
            orderId: orderId,
            orderDetailId: selectedOrderDetail.id
        }
        addCut(body)
            .then(res => {
                setCuts(prevState => ([...prevState, res.data]))
                setRoll()
                setIsOpenCutModal(false)
                toast.success('Ürün eklendi')
            })
        setIsOpenCutModal(false)
    }

    const onClickDeleteCut = (id) => {
        deleteCut(id)
            .then(res => {
                setCuts(prevState => prevState.filter(p => p.id !== id))
                toast.success('Ürün kaldırıldı')
            })
    }

    const onClickEditCut = (cut) => {
        setSelectedOrderDetail(cut.orderDetail)
        setIsOpenCutUpdateModal(true)
        setQuantity(cut.quantity)
        setRoll(cut.roll)
        setSelectedCutId(cut.id)
    }

    const onClickUpdateCut = () => {
        const body = {
            rollId: roll?.id,
            quantity,
            orderDetailId: selectedOrderDetail.id
        }
        updateCut(selectedCutId, body)
            .then(res => {
                setCuts(prev => prev.map(p => p.id === selectedCutId ? res.data : p))
                toast.success('Kaydedildi')
                setIsOpenCutUpdateModal(false)
                setSelectedOrderDetail()
                setQuantity('')
                setRoll()
                setSelectedCutId('')
            }).catch(err => {

            })
    }

    return (
        <div>
            <div>
                <label className='text-3xl block mb-5'> Sevkiyat</label>
            </div>
            <div className='grid grid-cols-2'>
                <div className='col-span-1 border-e pe-5'>
                    <div className='mb-5'>
                        <div className='border-b border-zinc-600'>
                            <label className='mb-4 block text-xl'>Gidecek Ürünler:</label>
                            {
                                orderDetails.map((detail, index) => (
                                    <div key={index} className='flex justify-between py-1'>
                                        <div className='flex gap-x-2 text-sm items-center'>
                                            <label>{index + 1}. </label>
                                            <ProductLabel state={detail.product} />
                                            <span className='bg-green-700 px-2 py-1 rounded-full text-xs text-white'>{detail.unitPrice} {order.currency}/m </span>
                                        </div>
                                        <label> {formatNumber(detail.quantity)} m</label>
                                    </div>
                                ))
                            }
                        </div>
                        <div className='flex justify-between py-1'>
                            <label>Toplam </label>
                            <label>{formatNumber(orderDetails.reduce((a, c) => a + c.quantity, 0).toFixed(2))} m</label>
                        </div>

                    </div>
                </div>
                <div className='col-span-1 pl-5'>
                    <div className='mb-5'>
                        <div>
                            <label className='mb-4 block text-xl'>Gönderilen Ürünler:</label>
                            {
                                cuts.map((cut, index) => (
                                    <div key={index} className='flex justify-between py-1 border-b border-black mb-2'>
                                        <div className='text-sm items-center'>
                                            <div className='flex gap-x-2 items-center'>
                                                <label>{index + 1}. </label>
                                                <ProductLabel state={cut.roll.product} />
                                                {cut.orderDetail && <span className='bg-green-700 text-white px-2 py-1 text-xs rounded-full'>{cut.orderDetail.unitPrice} {order.currency}/m </span>}
                                            </div>
                                            {cut.roll.boilerCode && <span className='pl-2'>Kazan no:  {cut.roll.boilerCode}</span>}
                                        </div>
                                        <div className='flex items-center gap-x-5'>
                                            <label> {cut.quantity} m</label>
                                            {
                                                !order.charged &&
                                                <>
                                                    <span className='cursor-pointer hover:scale-125 hover:text-blue-600 duration-150' onClick={() => onClickEditCut(cut)} >
                                                        <AiFillEdit />
                                                    </span>
                                                    <FaMinus className='hover:scale-125 cursor-pointer duration-150 hover:text-red-600' onClick={() => onClickDeleteCut(cut.id)} />
                                                </>
                                            }
                                        </div>
                                    </div>
                                ))
                            }
                        </div>
                        <div className='flex justify-between py-1'>
                            <label>Toplam </label>
                            <label>{formatNumber(cuts.reduce((a, c) => a + c.quantity, 0).toFixed(2))} m</label>
                        </div>
                    </div>
                    {
                        !order.charged &&
                        <Button
                            text='Ekle'
                            variant='blue'
                            onClick={() => setIsOpenCutModal(true)}
                        />
                    }

                </div>
            </div>

            {/* ADD CUT MODAL */}
            <Transition appear show={isOpenCutModal} as={Fragment}>
                <Dialog as="div" className="relative z-10" onClose={() => setIsOpenCutModal(false)}>
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <div className="fixed inset-0 bg-black/25" />
                    </Transition.Child>

                    <div className="fixed inset-0 overflow-y-auto">
                        <div className="flex min-h-full items-center justify-center p-4 text-center">
                            <Transition.Child
                                as={Fragment}
                                enter="ease-out duration-300"
                                enterFrom="opacity-0 scale-95"
                                enterTo="opacity-100 scale-100"
                                leave="ease-in duration-200"
                                leaveFrom="opacity-100 scale-100"
                                leaveTo="opacity-0 scale-95"
                            >
                                <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all">
                                    <Dialog.Title
                                        as="h3"
                                        className="text-lg font-medium leading-6 text-gray-900"
                                    >
                                    </Dialog.Title>
                                    <div className='flex gap-x-5 mb-3'>
                                        <input
                                            type='number'
                                            className='w-full px-2 py-1 border border-2 border-zinc-600 rounded-md'
                                            label='Barkod Numarası'
                                            placeholder='Barkod numarası girin...'
                                            value={upc}
                                            onChange={e => setUpc(e.target.value)}
                                        />
                                        <Button
                                            text='Ara'
                                            variant='blue'
                                            onClick={onClickGetRoll}
                                        />
                                    </div>
                                    {
                                        roll &&
                                        <div className='mb-3'>
                                            <label className='block'>  Ürün Adı : {roll.product.collectionName}</label>
                                            <label className='block'>  Ürün Kodu : {roll.product.collectionCode}</label>
                                            {
                                                roll.product.color &&
                                                <>
                                                    <label className='block'>  Renk Adı: {roll.product.color?.name}</label>
                                                    <label className='block'>  Renk Kodu: {roll.product.color?.code}</label>
                                                </>
                                            }
                                            {
                                                roll.product.weight &&
                                                <>
                                                    <label className='block'>  Gramaj Adı: {roll.product.weight?.name}</label>
                                                    <label className='block'>  Gramaj Kodu: {roll.product.weight?.code}</label>
                                                </>
                                            }
                                            {
                                                roll.product.pattern &&
                                                <>
                                                    <label className='block'>  Desen Adı: {roll.product.pattern?.name}</label>
                                                    <label className='block'>  Desen Kodu: {roll.product.pattern?.code}</label>
                                                </>
                                            }
                                            <label className='block'>  Miktar: {roll.quantity} m</label>
                                            <label className='block'>  Kalan Miktar: {roll.restQuantity} m</label>
                                            <label className='block'>  Kazan No: {roll.boilerCode} m</label>
                                            <label className='block'>  Tarih: {formatDate(roll.date)}</label>
                                        </div>
                                    }

                                    <Input
                                        label='Miktar (m)'
                                        placeholder='Eklemek istediğiniz miktarı girin'
                                        onChange={e => setQuantity(e.target.value)}
                                        value={quantity}
                                        type='number'
                                    />
                                    <OrderDetailPicker
                                        label='Gidecek Ürün'
                                        currency={order.currency}
                                        items={orderDetails.filter(od => od.product.id === roll?.product?.id)}
                                        value={selectedOrderDetail}
                                        onChange={(details => setSelectedOrderDetail(details))}
                                        text={selectedOrderDetail ? <ProductLabel state={selectedOrderDetail?.product} currency={order.currency} unitPrice={selectedOrderDetail?.unitPrice} /> : 'Ürün seçin'}
                                    />

                                    <div className="mt-4 flex justify-between">
                                        <button
                                            type="button"
                                            className="flex items-center outline-none inline-flex justify-center rounded-md border border-transparent bg-emerald-100 px-4 py-2 text-sm font-medium text-emerald-900 hover:bg-emerald-200"
                                            onClick={onClickAddCut}
                                            disabled={!roll || !quantity || !selectedOrderDetail}
                                        >
                                            Kaydet
                                            {/* {pendingApiCall && <Spinner />} */}
                                        </button>
                                        <button
                                            type="button"
                                            className="outline-none inline-flex justify-center rounded-md border border-transparent bg-red-100 px-4 py-2 text-sm font-medium text-red-900 hover:bg-red-200"
                                            onClick={() => setIsOpenCutModal(false)}
                                        >
                                            İptal
                                        </button>
                                    </div>
                                </Dialog.Panel>
                            </Transition.Child>
                        </div>
                    </div>
                </Dialog>
            </Transition>

            {/* UPDATE CUT MODAL */}
            <Transition appear show={isOpenCutUpdateModal} as={Fragment}>
                <Dialog as="div" className="relative z-10" onClose={() => setIsOpenCutUpdateModal(false)}>
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <div className="fixed inset-0 bg-black/25" />
                    </Transition.Child>

                    <div className="fixed inset-0 overflow-y-auto">
                        <div className="flex min-h-full items-center justify-center p-4 text-center">
                            <Transition.Child
                                as={Fragment}
                                enter="ease-out duration-300"
                                enterFrom="opacity-0 scale-95"
                                enterTo="opacity-100 scale-100"
                                leave="ease-in duration-200"
                                leaveFrom="opacity-100 scale-100"
                                leaveTo="opacity-0 scale-95"
                            >
                                <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all">
                                    <Dialog.Title
                                        as="h3"
                                        className="text-lg font-medium leading-6 text-gray-900"
                                    >
                                    </Dialog.Title>

                                    {
                                        roll?.product &&
                                        <div className='mb-3'>
                                            <label className='block'>  Ürün Adı : {roll.product.collectionName}</label>
                                            <label className='block'>  Ürün Kodu : {roll.product.collectionCode}</label>
                                            {
                                                roll.product.color &&
                                                <>
                                                    <label className='block'>  Renk Adı: {roll.product.color?.name}</label>
                                                    <label className='block'>  Renk Kodu: {roll.product.color?.code}</label>
                                                </>
                                            }
                                            {
                                                roll.product.weight &&
                                                <>
                                                    <label className='block'>  Gramaj Adı: {roll.product.weight?.name}</label>
                                                    <label className='block'>  Gramaj Kodu: {roll.product.weight?.code}</label>
                                                </>
                                            }
                                            {
                                                roll.product.pattern &&
                                                <>
                                                    <label className='block'>  Desen Adı: {roll.product.pattern?.name}</label>
                                                    <label className='block'>  Desen Kodu: {roll.product.pattern?.code}</label>
                                                </>
                                            }
                                            <label className='block'>  Miktar: {roll.quantity} m</label>
                                            <label className='block'>  Kalan Miktar: {roll.restQuantity} m</label>
                                            <label className='block'>  Kazan No: {roll.boilerCode} m</label>
                                            <label className='block'>  Tarih: {formatDate(roll.date)}</label>
                                        </div>
                                    }

                                    <Input
                                        label='Miktar (m)'
                                        placeholder='Eklemek istediğiniz miktarı girin'
                                        onChange={e => setQuantity(e.target.value)}
                                        value={quantity}
                                        type='number'
                                    />
                                    <OrderDetailPicker
                                        label='Gidecek Ürün'
                                        currency={order.currency}
                                        items={orderDetails.filter(od => od.product?.id === roll?.product?.id)}
                                        value={selectedOrderDetail || 'Ürün seçin'}
                                        onChange={(details => setSelectedOrderDetail(details))}
                                        text={selectedOrderDetail ? <ProductLabel state={selectedOrderDetail?.product} currency={order.currency} unitPrice={selectedOrderDetail?.unitPrice} /> : 'Ürün seçin'}
                                    />

                                    <div className="mt-4 flex justify-between">
                                        <button
                                            type="button"
                                            className="flex items-center outline-none inline-flex justify-center rounded-md border border-transparent bg-emerald-100 px-4 py-2 text-sm font-medium text-emerald-900 hover:bg-emerald-200"
                                            onClick={onClickUpdateCut}
                                            disabled={!roll || !quantity}
                                        >
                                            Kaydet
                                            {/* {pendingApiCall && <Spinner />} */}
                                        </button>
                                        <button
                                            type="button"
                                            className="outline-none inline-flex justify-center rounded-md border border-transparent bg-red-100 px-4 py-2 text-sm font-medium text-red-900 hover:bg-red-200"
                                            onClick={() => setIsOpenCutModal(false)}
                                        >
                                            İptal
                                        </button>
                                    </div>
                                </Dialog.Panel>
                            </Transition.Child>
                        </div>
                    </div>
                </Dialog>
            </Transition>
        </div>
    )
}

export default OrderShipmentPage